// extracted by mini-css-extract-plugin
export default {"head":"Products_head__zolUh","title":"Products_title__-30kv","products":"Products_products__KNspk","wrapper":"Products_wrapper__1D0u4","empty":"Products_empty__KyHqh"};